module.exports = __webpack_public_path__ + "static/media/dairycow.543f1b5f.jpg";